import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { Map } from './Map';
import { Provider, RootStore } from './stores';

import { Favorites } from './layers/Favorites';
import { Filter } from './layers/Filter';
import { Information } from './layers/Information';
import { Parking } from './layers/Parking';
import { Search } from './layers/Search';

import { AddLocationHelpModal } from './modals/addLocationModalBanner';
import { AddMyLocationsModal } from './modals/addMyLocationModal';
import { ConfirmDeleteCustomLocationModal } from './modals/confirmDeleteCustomLocationModal';
import { ConfirmDeleteModal } from './modals/confirmDeleteModal';
import { NoFavouritesModal } from './modals/noFavouritesModal';
import { NoLocationModal } from './modals/noLocationModal';
import { NoParkingSpotsModal } from './modals/noParkingSpots';
import { TooManyParkingRequestsModal } from './modals/tooManyParkingRequests';

import { initTranslations, useTranslation } from './helpers/translations';

export const TranslationContext = React.createContext();
export const TranslationsProvider = TranslationContext.Provider;

export const App = ({ store = RootStore, translateHook = null, ...props }) => {
  if (!translateHook) {
    initTranslations(
      [store.config.gysService.language],
      store.config.translationUrl,
    );
  }
  return (
    <Provider value={store}>
      <TranslationsProvider value={translateHook ?? useTranslation}>
        <CookiesProvider>
          <Map {...props}>
            <Favorites />
            <Filter />
            <Information />
            <Parking />
            <Search />
            <AddLocationHelpModal />
            <ConfirmDeleteModal />
            <ConfirmDeleteCustomLocationModal />
            <NoFavouritesModal />
            <AddMyLocationsModal />
            <NoLocationModal />
            <TooManyParkingRequestsModal />
            <NoParkingSpotsModal />
          </Map>
        </CookiesProvider>
      </TranslationsProvider>
    </Provider>
  );
};
